const leadPreferences = {
  leadPreferences: {
    pageHeader: 'Leads Voorkeuren',
    confirmMessage:
      'Weet u zeker dat u uw lead-voorkeuren wilt opslaan en naar de Gebruiker Toevoegen-pagina wilt gaan?',
    notInterested: {
      radioOptions0: 'Gebrek aan tijd/middelen om nieuwe leads te onderhouden',
      radioOptions1: 'Alleen geïnteresseerd in getekende huiseigenaarscontracten',
      radioOptions2: 'Wil geen prijsklasse bekendmaken',
      radioOptions3: 'Andere',
      selectReason: 'Selecteer een reden om af te zien van het Enphase Leads Programma.',
      otherComments: 'Eventuele andere opmerkingen'
    },
    programOverview: {
      notInterestedText: 'We zijn momenteel niet geïnteresseerd in deelname aan het Enphase Leads programma'
    },
    serviceDetailsSection: {
      min: 'Min',
      max: 'Max.',
      maxLessMin: 'Maximale waarde kan niet lager zijn dan of gelijk aan de Min-waarde',
      enterInRange: 'Voer alleen getallen in tussen %{serviceMInValue} en %{serviceMaxValue}.',
      note: 'Noot:',
      noteText:
        'Op basis van deze input wordt een prijsklasse aan de huiseigenaar getoond. Deze prijs moet inclusief belastingen zijn, maar niet inclusief incentives.',
      noteTextAus:
        'Op basis van deze input wordt er een prijsklasse aan de huiseigenaar getoond . Deze prijs dient inclusief BTW te zijn, maar zonder incentives.',
      sizeRange: 'Maatbereik',
      pricePerkWh: 'Prijs per kWh',
      lessThan20kWh: 'Minder dan 20 kWh',
      greaterThan20kWh: '20 tot 40 kWh'
    },
    serviceAreaSection: {
      title: 'Toegang tot het beheers- en servicebereik',
      manageAdminAccess: 'Beheerderstoegang beheren',
      addNewUser: '+ Nieuwe gebruiker toevoegen',
      selectOneAdmin:
        'Selecteer een admin van uw bedrijf die het enige aanspreekpunt zal zijn voor het geval Enphase u wil bereiken voor escalaties met betrekking tot een lead.',
      selectUser: 'Selecteer Gebruiker',
      otherAdmin:
        '#De andere admingebruikers in de bovenstaande lijst zullen nog steeds waarschuwingen ontvangen voor alle nieuwe leads en hun updates. Ze kunnen deze uitschakelen door hun notificatievoorkeuren bij te werken indien nodig.',
      serviceArea: 'Servicegebied',
      addServiceAreas: ''
    },
    addUserDialog: {
      yes: 'Ja'
    },
    acModule: {
      optIn: 'Kies voor beschikbaarheid voor de het installeren van Enphase Energized AC Modules',
      description:
        'Huiseigenaar toont interesse in een op AC-modules gebaseerd systeem. U zult de AC-modules aanschaffen en installeren. Enphase Energized AC Modules combineren de nieuwste geavanceerde micro-omvormertechnologie van Enphase met hoogrenderende zonnepanelen. Ze combineren esthetiek en prestaties tot een elegant product dat de installatietijd verkort door de omvormer en het paneel te combineren in één enkele unit.'
    },
    sampleQuotes: {
      title: 'Indicatieve prijzen voor Leads',
      useSlider:
        'Gebruik de schuifregelaars hieronder om te zien hoe uw prijsklasse-input wordt vertaald naar een indicatieve prijsklasse voor huiseigenaren voor de verschillende systeemgroottes.',
      description:
        'Op basis van uw input wordt hier de indicatieve prijsklasse weergegeven die huiseigenaren zullen zien. U kunt ook controleren hoe de prijsklasse zal variëren per systeemgrootte.',
      solarOnly: 'Zonne-energie-installatie',
      storageOnly: 'Opslaginstallatie',
      solarStorage: 'Zonne-energie + opslaginstallatie',
      solarExpansion: 'Zonne-uitbreiding',
      turnkeyACM: 'Opslaginstallatie + ACM-upgrade',
      microUpgrade: 'Micro-omvormer Upgrade',
      turnkeyIQSeries: 'Opslaginstallatie + Micro-omvormer Upgrade',
      installationACM: 'Opslaginstallatie + ACM-upgrade',
      installationIQSeries: 'Opslaginstallatie + Micro-omvormer Upgrade',
      installationSolar: 'Zonne-installatie',
      installationStorage: 'Opslaginstallatie/uitbreiding',
      turnkeyNew: 'Kant-en-klare prijs voor nieuwe huiseigenaren',
      turnKeyExisting: 'Kant-en-klare prijs voor bestaande huiseigenaren',
      turnkeyNewUS: 'Kant-en-klare prijs voor huiseigenaren',
      installationUS: 'Installatieprijs alleen voor huiseigenaren',
      installation: 'Installation-only offertes voor M-190 Micro-klanten',
      turnkeyPrice: 'Kant-en-klare prijs',
      installation2: 'Installation-only prijs voor doorverwezen klanten',
      installation3: 'Alleen Installatie prijs voor bestaande huiseigenaren',
      microinverterFootnote: 'Micro-omvormer upgradeprijs kan worden toegevoegd afhankelijk van hoe oud de site is',
      solar: 'Zonne-energie',
      storage: 'Opslag'
    },
    operationMaintenance: {
      label: 'Keuzemogelijkheid beschikbaarheid voor O&M-diensten',
      description:
        'Operations and Maintenance (O&M) diensten omvatten de ondersteuning en het onderhoud van bestaande Enphase systemen en Orphan Systems (werklocaties met een inactieve installateur). Alle O&M leads worden voorzien van volledige site details en ondersteuningshistorie. Voor alle O&M leads geldt de Enphase standaard productgarantie. Eerdere fabrieksgarantie is niet van toepassing op de Orphan Systems.'
    },
    leadProgram: {
      optIn: 'Deelnemen aan het Enphase Leads-programma',
      description:
        'Huiseigenaren nemen contact op met Enphase voor nieuwe installaties, upgrades en doorlopend systeemonderhoud. Als Enphase partner heeft u nu de mogelijkheid om deze huiseigenaren te bedienen via het Enphase Leads Programma, dat u zal matchen met potentiële huiseigenaren.',
      programHighlights: 'Belangrijkste punten uit het programma:',
      keyTerms1: 'Enphase zorgt voor gratis gekwalificeerde leads binnen uw servicegebied.',
      keyTerms2: 'Het klantprofiel en de projectgegevens worden voor elke lead vóór het eerste contact verstrekt.',
      keyTerms3: 'Enphase zal helpen bij de planning, afspraken, project-updates en technische ondersteuning.',
      keyTerms4:
        'Van de installateurs wordt verwacht dat zij binnen 2 werkdagen reageren, contact opnemen met elke lead en een offerte sturen.',
      keyTerms5: 'Als onderdeel van het programma mogen alleen Enphase producten worden gebruikt',
      leadProgramPreferences: "Voorkeuren voor leidende programma's",
      someLeads:
        'Voor sommige leads zijn misschien enkel installatiediensten nodig. Geef hieronder aan of u aan dergelijke leads wilt deelnemen.',
      tooltipTitle1:
        'Diensten die u aan huiseigenaren levert. Enphase zal u matchen met huiseigenaren op basis van uw geselecteerde servicevoorkeuren.',
      turnKey: 'Kant-en-klare diensten',
      tooltipTitle2: 'U zorgt voor alle apparatuur, het ontwerp, vergunningen en installatiediensten',
      installationService: 'Alleen installatiediensten',
      tooltipTitle3:
        'Huiseigenaar kiest ervoor om Enphase apparatuur aan te schaffen bij de Enphase winkel. U zorgt voor de overige apparatuur, het ontwerp, de vergunningen en de installatie.',
      solarNew: 'Zonne-energie - Nieuwe installaties',
      solarUpgrades: 'Zonne-energie - Upgrades',
      storageNew: 'Opslag - Nieuwe installaties'
    },
    textContent: {
      preference: {
        title: 'Leads Programmavoorkeuren',
        caption: 'Disclaimer',
        description:
          'Enphase zal de door u verstrekte prijsstelling voor elke voorkeur hieronder aan de huiseigenaren laten zien. Met een disclaimer zal worden aangetoond dat deze prijsstelling budgettair is en alleen de omvang van het werk voor een typisch systeem weergeeft. De werkelijke prijzen zijn onderhevig aan verandering, afhankelijk van de locatie, het type dak/plaats, de upgrade van het elektrische paneel en de verhuizing van het systeem naar een andere plaats.',
        atleaseOne: '* selecteer ten minste één dienst'
      },
      programreview: {
        title: 'Programmaoverzicht',
        description:
          'Huiseigenaren nemen contact op met Enphase voor nieuwe installaties, upgrades en doorlopend systeemonderhoud. Als Enphase partner heeft u nu de mogelijkheid om deze huiseigenaren te bedienen via het Enphase Leads Programma dat u zal matchen met potentiële huiseigenaren. Bekijk de belangrijkste termen hieronder en geef uw voorkeuren voor dit programma aan.'
      },
      keyProgramTerms: {
        title: 'Sleutelbegrippen van het programma',
        enphaseProduct: 'Als onderdeel van het programma mogen alleen Enphase producten worden gebruikt',
        appointment: 'Enphase zal helpen bij het plannen van afspraken en andere ondersteuning bieden waar nodig.',
        contact: 'Van de installateurs wordt verwacht dat zij binnen 2 werkdagen contact opnemen met elke lead.',
        project: 'Het klantprofiel en de projectgegevens worden voor elke lead vóór het eerste contact verstrekt.',
        verifiedAccount: 'Enphase zorgt voor gratis gekwalificeerde leads uit uw servicegebied.'
      },
      TurnKey: {
        title: 'Kant-en-klare diensten',
        description:
          'Kant-en-klare diensten (Turn-key Services) betekent dat de installateur alle materiaallijsten, het ontwerp, de vergunningen, de installatie en de inbedrijfstelling voor zover van toepassing, ter beschikking stelt. De aangegeven prijs is inclusief de totale geschatte kosten voor de huiseigenaar om een systeem te activeren.',
        solar: {
          indicativePricing: 'Indicatief prijsbereik per Watt',
          quoteSizeIn: 'kW',
          main: 'Zonne-energie - Installatie',
          sub: 'Een nieuwe installatie voor het zonne-energiesysteem.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Biedt kant-en-klare prijzen en levert alle benodigde materialen zoals modules, micro-omvormers (of als alternatief AC-modules), IQ-combiner box, accessoireskit, stroomonderbrekers, GSM-modem, kabels en rekken.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub:
                'De prijsklasse is voor een typische site en omvat geen upgrade van het hoofdpaneel en een speciaal soort dak.'
            }
          }
        },
        storage: {
          indicativePricing: 'Indicatieve prijsklasse per kWhr',
          indicativePricingStorageSlabs: 'Indicatieve prijs per kWh',
          main: 'Opslag - Installatie',
          quoteSizeIn: 'kWh',
          sub: 'Een nieuwe installatie voor het opslagsysteem',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Biedt een kant-en-klare prijsstelling en levert alle benodigde materialen zoals Encharge opslag, Enpower-schakelaar, GSM-modem, accessoireskit en kabels.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub: 'Indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel.'
            }
          }
        },
        microinverter: {
          indicativePricing: 'Indicatieve prijsklasse per Watt',
          main: 'Micro-omvormer - Upgrade',
          quoteSizeIn: 'kW',
          sub:
            'Micro-omvormer upgrade voor een M-serie (bijv. M-215, M-250) gebaseerd zonnesysteem naar een nieuw IQ-gebaseerd zonnesysteem, dat meestal gepaard gaat met een "Opslag - Installatie"',
          sub2:
            'Micro-omvormer upgrade voor een M-serie (bijv. M-215, M-250) gebaseerd zonnesysteem naar een nieuw IQ-gebaseerd zonnesysteem',
          subUS:
            'Microinverter upgrade voor een bestaand zonne-energie systeem om deze om te zetten in een nieuw zonne-energie systeem op basis van IQ.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub: 'Biedt een kant-en-klare prijsstelling en levert alle benodigde materiaallijsten.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub:
                'Indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel en de upgrade van het zonnepaneel.'
            }
          }
        }
      },
      installationOnly: {
        title: "Alleen installatiediensten (voor speciale programma's)",
        titleUS: 'Alleen installatiediensten',
        sub: '(bijv. huiseigenaren met M-190-based zonnepanelen, Enphase vrienden & familie)',
        description:
          'Installatie alleen diensten betekent dat de huiseigenaar de Enphase materiaallijst van de Enphase Store aanschaft. Alle andere materialen en diensten worden rechtstreeks door de installateur geleverd (bedrading, stellingen, ontwerp, vergunning, installatie en inbedrijfstelling zoals van toepassing).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Indicatief prijsbereik voor alleen installatie per Watt',
          main: 'Zonne-energie - Installatie',
          sub:
            "Nieuwe installatie voor speciale programma's of een volledige upgrade van een M-190/M-210/M-175/D380-based zonnesysteem",
          subUS: 'Een nieuwe installatie voor het zonne-energiesysteem.',
          details: {
            homeOwner: {
              main: 'Huiseigenaar',
              sub:
                'De aankoop van de benodigde materiaallijst bij de Enphase Store, zoals AC-modules, IQ-Combiner box, accessoireskit en stroomonderbrekers.'
            },
            installer: {
              main: 'Installateur',
              sub: 'Voorziet in de rekken, bedrading, vergunningen, installatie en inbedrijfstelling.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub:
                'De indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel en de installatie op speciale daken.'
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Indicatieve prijsstelling installatie alleen bereik per kWhr',
          indicativePricingStorageSlabs: 'Indicatieve prijs voor alleen installatie per kWh',
          main: 'Opslag - Installatie',
          sub:
            "Opslagmogelijkheid bij een bestaand zonnesysteem voor speciale programma's of voor een M-190/M-210/M-175/D380-based zonnesysteem",
          subUS: 'Een nieuwe installatie voor het opslagsysteem',
          details: {
            homeOwner: {
              main: 'Huiseigenaar',
              sub:
                'Vereiste aankoopfactuur bij Enphase Store, zoals Encharge opslag, Enpower switch, accessoireskit, Envoy Gateway (indien nodig IQ Combiner box, GSM-Modem en/of Consumption CT).'
            },
            installer: {
              main: 'Installateur',
              sub: 'voorziet in de vergunningen de installatie en de inbedrijfstelling.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub: 'Indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel.'
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Indicatief prijsbereik voor installation-only per Watt',
          main: 'Micro-omvormers - Upgrade',
          sub: `Micro-omvormer upgrade voor een M-190/M-210/M-175/D380-gebaseerd zonnesysteem naar een nieuw IQ-gebaseerd zonnesysteem, dat meestal gepaard gaat met een "Opslag - Installatie"`,
          sub2:
            'Micro-omvormer upgrade voor een M-serie (bijv. M-215, M-250) gebaseerd zonnesysteem naar een nieuw IQ-gebaseerd zonnesysteem',
          subUS:
            'Microinverter upgrade voor een bestaand zonne-energie systeem om deze om te zetten in een nieuw zonne-energie systeem op basis van IQ.',
          details: {
            homeOwner: {
              main: 'Huiseigenaar',
              sub:
                'De aankoop van de benodigde materiaallijst bij de Enphase Store, zoals Micro-omvormers, IQ Combiner box, Accessoireskit en Stroomonderbrekers.'
            },
            installer: {
              main: 'Installateur',
              sub: 'Voorziet in vergunningen, vervangen, aanbevelen en recyclen van oude Micro-omvormers.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub: 'Indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel en veranderingen in de rekken.'
            }
          }
        }
      },
      omServices: {
        title: 'Enphase O&M-diensten',
        om: {
          main: 'Keuze voor deelname in Enphase O&M-diensten',
          pre: -'Inclusief orphan systemen',
          sub:
            'Operations and Maintenance (O&M) diensten omvatten de ondersteuning en het onderhoud van bestaande Enphase systemen en Orphan Systems (sites met een inactieve installateur). Alle O&M leads worden voorzien van volledige informatie betreffende de werklocatie en de ondersteuningshistorie. Voor alle O&M leads geldt de Enphase standaard productgarantie. Eerdere fabrieksgarantie is niet van toepassing op de Orphan Systems.'
        }
      },
      otherServices: {
        title: 'Andere voorkeuren',
        buy: 'We zijn bereid om producten te kopen van',
        acModule: {
          main: 'We zijn bereid om Enphase Energized AC Modules te installeren',
          sub1: 'Enphase Energized AC-modules ',
          sub2:
            'combineren de nieuwste Micro-omvormer-technologie van Enphase met de hoogrenderende zonnepanelen. Ze combineren esthetiek en prestaties tot een elegant product dat de installatietijd verkort door de omvormer en het paneel te combineren in één enkele unit. Door voor deze optie te kiezen, zal Enphase u matchen met de huiseigenaren die bereid zijn om AC-modules te installeren.'
        },
        enstore: {
          main: 'Enphase Store',
          sub1: 'Enphase Store ',
          sub2:
            'is een one-stop-shop voor Solar- en opslagproducten met gegarandeerde levering. Opslag vereist geen minimale bestelhoeveelheid en biedt real time levering en online tracking.',
          subIndia: `is a one-stop-shop for Solar products with guaranteed delivery. Store requires no minimum order quantity and provides real time delivery and online tracking.​`
        },
        distributor: {
          main: 'Enphase Distributeurs',
          sub1: 'Enphase-distributeurs',
          sub2: ' alle Enphase producten en andere benodigde accessoires voor uw Solar & Storage oplossing te leveren',
          subIndia: ` supply all Enphase products and other required accessories for your Solar solution​`
        },
        permitAssistance: {
          main: 'We zijn geïnteresseerd in vergunningsondersteuning van Enphase',
          sub:
            'Enphase zal u helpen met Solar en Storage Permit Packages (vergunningspakketten) voor uw locaties die u kunt indienen bij uw lokale overheid voor goedkeuring.'
        },
        financeProvider: {
          main: 'We bieden financiële opties voor huiseigenaren',
          no: 'Geen',
          yes: 'Ja',
          financeProvider: 'Financieringsaanbieders',
          others: 'Andere aanbieders',
          addMultiple: 'maximaal 3 (gescheiden door komma)',
          requiredSelection: 'Vereiste selectie',
          atLeastOneError: `Ongeldige financieringsaanbieders (voer ten minste één providernaam in wanneer "Andere providers" is geselecteerd)`
        }
      },
      serviceArea: {
        name: 'SERVICEGEBIEDEN TOEVOEGEN',
        sub: 'Geen gebied toegevoegd',
        description:
          'Voeg uw servicegebieden toe. Dit is nodig om Enphase in staat te stellen u te matchen met potentiële huiseigenaren.'
      },
      qualifyLeads: {
        mainSection: 'Wilt u dat de vertegenwoordigers van Enphase de leads telefonisch kwalificeren voordat ze de leads met u delen?',
        moreInfo: 'Is er specifieke informatie die wij voor uw leads kunnen verzamelen',
        infoWeCollect: 'Wilt u weten welke informatie we tijdens ons kwalificatieproces verzamelen',
        subSection: 'Wilt u dat we een gekwalificeerde lead aan een van uw vertegenwoordigers overdragen terwijl we de woningeigenaar aan de telefoon hebben?',
        details: 'Selecteer één beheerdergebruiker bij uw bedrijf aan wie we dergelijke leads kunnen overdragen',
        icCheckList: 'Qualification Checklist',
        selectOption: 'Please select an option',
        selectUser: 'Please select a user',
      }
    },
    textContentAu: {
      preference: {
        title: 'Leads Programmavoorkeuren',
        caption: 'Disclaimer',
        description:
          'Enphase zal de door u verstrekte prijsstelling voor elke voorkeur hieronder aan de huiseigenaren laten zien. Met een disclaimer zal worden aangetoond dat deze prijsstelling budgettair is en alleen de omvang van het werk voor een typisch systeem weergeeft. De werkelijke prijzen zijn onderhevig aan verandering, afhankelijk van de locatie, het type dak/plaats, de upgrade van het elektrische paneel en de verhuizing van het systeem naar een andere plaats.',
        atleaseOne: '* selecteer ten minste één dienst'
      },
      programreview: {
        title: 'Programmaoverzicht',
        description:
          'Huiseigenaren nemen contact op met Enphase voor nieuwe installaties, upgrades en doorlopend systeemonderhoud. Als Enphase partner heeft u nu de mogelijkheid om deze huiseigenaren te bedienen via het Enphase Leads Programma dat u zal matchen met potentiële huiseigenaren. Bekijk de belangrijkste termen hieronder en geef uw voorkeuren voor dit programma aan.'
      },
      keyProgramTerms: {
        title: 'Sleutelbegrippen van het programma',
        enphaseProduct: 'Als onderdeel van het programma mogen alleen Enphase producten worden gebruikt',
        appointment: 'Enphase zal helpen bij het plannen van afspraken en andere ondersteuning bieden waar nodig.',
        contact: 'Van de installateurs wordt verwacht dat zij binnen 2 werkdagen contact opnemen met elke lead.',
        project: 'Het klantprofiel en de projectgegevens worden voor elke lead vóór het eerste contact verstrekt.',
        verifiedAccount: 'Enphase zorgt voor gratis gekwalificeerde leads uit uw servicegebied.'
      },
      TurnKey: {
        title: 'Turn-key services (Kant-en-klare diensten)',
        description:
          'Onder kant-en-klare diensten wordt verstaan de levering van een materiaallijst, het ontwerp van het systeem, het regelen van vergunningen, de installatie en de inbedrijfstelling, voor zover van toepassing. De installateur doet de project- en locatiebeoordeling voordat hij een gedetailleerde offerte opstelt. De aangegeven prijs moet de totale geschatte kosten voor de huiseigenaar voor een systeemactivatie omvatten.',
        solar: {
          indicativePricing: 'Indicatief prijsbereik per Watt',
          quoteSizeIn: 'kW',
          main: 'Zonne-energie - Installatie',
          sub: 'Een nieuwe installatie voor het zonne-energiesysteem.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Voorziet in kant-en-klare prijzen en levert alle benodigde materialen zoals modules, micro-omvormers, accessoires, stroomonderbrekers, GSM-modem, kabels en rekken.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub:
                'De prijsklasse is voor een typische werklocatie en omvat geen upgrade van het hoofdpaneel en een speciaal soort dak.'
            }
          }
        },
        storage: {
          indicativePricing: 'Indicatieve prijsklasse per kWhr',
          main: 'Opslag - Installatie',
          quoteSizeIn: 'kWh',
          sub: 'Een nieuwe installatie voor het opslagsysteem',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub:
                'Voorziet in een kant-en-klare prijsstelling en levert alles van de benodigde materiaallijst, zoals ACB-opslag, beugels, bedrading en stroomonderbrekers.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub: 'Indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel.'
            }
          }
        },
        microinverter: {
          indicativePricing: 'Indicatieve prijsklasse per Watt',
          main: 'Micro-omvormer - Upgrade',
          quoteSizeIn: 'kW',
          sub:
            'Micro-omvormer-upgrade voor een M-serie (bijv. M-215, M-250) gebaseerd zonnesysteem naar een nieuw IQ-gebaseerd zonnesysteem, dat meestal gepaard gaat met een "Opslag - Installatie".',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub: 'Biedt een kant-en-klare prijsstelling en verzorgt alles omtrent de materiaallijst.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub:
                'Indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel en de upgrade van het zonnepaneel.'
            }
          }
        },
        solarExpansion: {
          indicativePricing: 'Indicatieve prijsklasse per Watt',
          quoteSizeIn: 'kW',
          main: 'Uitbreiding van het zonnesysteem',
          sub: 'Uitbreiding van bestaande Enphase- en niet-Enphase-zonnesystemen',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Installateur',
              sub: 'Biedt een kant-en-klare prijsstelling en verzorgt alles omtrent de materiaallijst.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub:
                'De prijsklasse is voor een typische werklocatie en omvat geen upgrade van het hoofdpaneel en voor een speciaal soort dak.'
            }
          }
        }
      },
      installationOnly: {
        title: "Installation-only services (voor speciale programma's)",
        sub: '(bijv. Orphaned systems moeten worden vervangen/gerepareerd, batterij-upgrade, Envoy upgrade)',
        description:
          'Installation-only services betekent dat de huiseigenaar de Enphase materiaallijst van de Enphase Store aanschaft. Alle andere materialen en diensten worden rechtstreeks door de installateur geleverd (bedrading, stellingen, ontwerp, vergunningen, installatie en inbedrijfstelling zoals van toepassing).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Indicatief prijsbereik voor installation-only per Watt',
          main: 'Zonne-energie - Installatie',
          sub:
            "Nieuwe installaties voor speciale programma's zoals referral leads van Enphase klanten, installateurs en medewerkers.",
          details: {
            homeOwner: {
              main: 'Huiseigenaar',
              sub:
                'De aankoop van de benodigde materiaallijst van de Enphase Store, zoals Micro-omvormers, accessoireskit, Envoy en Stroomonderbrekers.'
            },
            installer: {
              main: 'Installateur',
              sub: 'Verzorgt modules, rekken, bedrading, vergunningen, installatie en inbedrijfstelling.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub:
                'De indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel en de installatie op speciale daken.'
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Indicatieve prijsstelling installatie alleen bereik per kWhr',
          main: 'Opslag - Uitbreiding of installatie',
          sub: "ACB Opslaguitbreiding of installatie op een bestaand zonnesysteem voor speciale programma's",
          details: {
            homeOwner: {
              main: 'Huiseigenaar',
              sub: 'Aankopen benodigde materiaallijst van Enphase Store zoals ACB opslag, Beugel.'
            },
            installer: {
              main: 'Installateur',
              sub: 'Zorgt voor installatie en inbedrijfstelling.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub: 'Indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel.'
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Indicatief prijsbereik voor alleen installatie per Watt',
          main: 'Micro-omvormer - Upgrade',
          sub:
            'Micro-omvormer-upgrade voor een M-190/M-210/M-175/D380-based zonnesysteem naar een nieuw IQ-based zonnesysteem dat gewoonlijk bij een "Opslag - Installatie" hoort.',
          details: {
            homeOwner: {
              main: 'Huiseigenaar',
              sub:
                'De aankoop van de benodigde materiaallijst bij de Enphase Store, zoals Micro-omvormers, IQ Combiner box, Accessoireskit en Stroomonderbrekers.'
            },
            installer: {
              main: 'Installateur',
              ub: 'Zorgt voor het toestaan, vervangen, aanbevelen en recyclen van oude Micro-omvormers.'
            },
            assumptions: {
              main: 'Veronderstellingen',
              sub: 'Indicatieve prijsklasse omvat niet de upgrade van het hoofdpaneel en veranderingen in de rekken.'
            }
          }
        }
      },
      omServices: {
        title: 'Enphase O&M-diensten',
        om: {
          main: 'Keuzemogelijkheid voor deelname in Enphase O&M-diensten',
          pre: '- Inclusief Orphaned systemen',
          sub:
            'Operations and Maintenance (O&M) diensten omvatten de ondersteuning en het onderhoud van bestaande Enphase systemen en Orphan Systems (sites met een inactieve installateur). Alle O&M leads worden voorzien van de volledige informatie betreffende de werklocatie en ondersteuningshistorie. Voor alle O&M leads geldt de Enphase standaard productgarantie.'
        }
      },
      otherServices: {
        title: 'Andere voorkeuren',
        buy: 'Ik ben bereid producten te kopen van',
        acModule: {
          main: 'Ik ben bereid om Enphase Energized AC Modules te installeren.',
          sub1: 'Enphase Energized AC-modules ',
          sub2:
            'combineren de nieuwste Micro-omvormer technologie van Enphase met de hoogrenderende zonnepanelen. Ze combineren esthetiek en prestaties tot een elegant product dat de installatietijd verkort door de omvormer en het paneel te combineren in één enkele unit. Door voor deze optie te kiezen, zal Enphase u matchen met de huiseigenaren die bereid zijn om AC-modules te installeren.'
        },
        enstore: {
          main: 'Enphase Store',
          sub1: 'Enphase Store ',
          sub2:
            'is een one-stop-shop voor zonne-energie- en opslagproducten met een gegarandeerde levering. Opslag vereist geen minimale bestelhoeveelheid en biedt real-time levering en online tracking.'
        },
        distributor: {
          main: 'Enphase Distributeurs',
          sub1: 'Enphase-distributeurs',
          sub2:
            'leveren alle Enphase producten en andere benodigde accessoires voor uw Solar & Storage-oplossing (Oplossingen voor zonne-energie en opslag)'
        }
      },
      serviceArea: {
        name: 'SERVICEGEBIEDEN TOEVOEGEN',
        sub: 'Geen gebied toegevoegd',
        description:
          'Voeg uw servicegebieden toe. Dit is nodig om Enphase in staat te stellen u te matchen met potentiële huiseigenaren.'
      }
    },
    getLink: `Krijg link`,
    linkSENewLeads: `Systeem schatting link voor nieuwe leads`,
    shareSELink: `Deel deze link met uw klanten om hen te helpen de grootte van hun Enphase systeem in te schatten en hun gegevens in te dienen om een voorsprong te krijgen in uw Enlighten Manager.`
  }
};

export default leadPreferences;
